if (!window.cardQuickAdd) {
  window.cardQuickAdd = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-quick-add]');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault();

    const container = button.closest('.card-product__quick-add');
    const error = container.querySelector('[data-quick-add-error]');
    const status = container.querySelector('[data-quick-add-status]');
    const spinner = button.querySelector('.loading__spinner');
    clearTimeout(button.addedTimer);
    button.classList.remove('is-added');
    error.hidden = true;
    status.textContent = '';
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-loading');
    spinner?.classList.remove('hidden');

    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
          sections: 'cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message);

      const bubble = document.getElementById('cart-icon-bubble');
      const html = data.sections?.['cart-icon-bubble'];
      if (bubble && html) {
        const source = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (source) bubble.innerHTML = source.innerHTML;
      }
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', productVariantId: button.dataset.variantId });

      status.textContent = button.dataset.addedMessage;
      button.classList.add('is-added');
      button.addedTimer = setTimeout(() => button.classList.remove('is-added'), 2000);
    } catch (e) {
      error.hidden = false;
      status.textContent = error.textContent.trim();
    } finally {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-disabled');
      spinner?.classList.add('hidden');
    }
  });
}
